// project imports
import logoIcon from 'assets/images/logo/simple-swift-soft.svg';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  return <img src={logoIcon} alt="Scale" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />;
}
